module.exports = __webpack_public_path__ + "img/esg-rz-spingan.6d764327.png";